<script setup lang="ts">
import { useStore } from '@/store/store'
const store = useStore()
store.commit('setPageTitle', 'Support client final')
</script>

<template>
  <q-page padding class="page"> </q-page>
</template>
